import { render } from "./WhiteLabelEdit.vue?vue&type=template&id=b4e79ace"
import script from "./WhiteLabelEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./WhiteLabelEdit.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/white-label/components/WhiteLabelEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b4e79ace"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b4e79ace', __exports__)) {
    api.reload('b4e79ace', __exports__)
  }
  
  module.hot.accept("./WhiteLabelEdit.vue?vue&type=template&id=b4e79ace", () => {
    api.rerender('b4e79ace', render)
  })

}


export default __exports__